/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import template from './email-translation-list-page.component.html';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {EmailTranslationApiService, EmailTranslationModel} from './email-translation-api.service';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-email-translation-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailTranslationListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.email-translations.email-translation';
  readonly showTeams = !!inject(LocalUserPermissions).getAllVisPermissions().MANAGE_SYSTEM;
  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'emailType', param: 'messageDefinition'},
    {label: 'applications', param: '', sortable: false},
    {label: 'locale', param: '', sortable: false},
    ...(this.showTeams ? [{label: 'team', param: '', sortable: false}] : []),
    {label: 'emailTemplate', param: '', sortable: false}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<EmailTranslationModel>(
    inject(EmailTranslationApiService),
    {listId: 'fullEmailTranslationList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
